import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { getSubmission } from './api';
import { connect } from 'react-redux';
import NotHaveAccess from '../components/shared/NotHaveAccess';

const withSubmission = (WrappedComponent) => {
    class WithSubmissionComponent extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                submission: undefined,
                isAuthorized: true
            }
        }

        componentDidMount() {
            const submissionId = this.props.match.params.id
            if (!!submissionId) {
                getSubmission(this.props.user, {id: submissionId}).then((response) => {
                    if (response.status === 200) {
                        let formBuildSubmission = Object.assign({}, response.data);
                        if (formBuildSubmission.occupancy && formBuildSubmission.occupancyDescription === 'Unknown') {
                            formBuildSubmission.occupancyDescription= ''
                        }
                        let insuredDetails = {};
                        formBuildSubmission.additionalInsuredArray ?
                            formBuildSubmission.additionalInsuredArray.map(ins => Object.assign(insuredDetails, {...ins})) : {};
                        formBuildSubmission = Object.assign(formBuildSubmission, insuredDetails);
                        this.setState({
                            submission: formBuildSubmission
                        })
                    }
                }).catch((error) => {
                    if (error.status === 401) {
                        this.setState({ isAuthorized: false });
                    }
                });
            }
        }

        render() {
            const submissionId = this.props.match.params.id

            if (!this.state.isAuthorized) {
                return <NotHaveAccess />
            } else {
                if ((isEmpty(this.props.submission) || !this.props.submission) && !!this.state.submission) {
                    // For existing submission, GET request to DB
                    return <WrappedComponent {...this.props} submission={this.state.submission} />
                } else if (!isEmpty(this.props.submission) || !submissionId) {
                    // For brand new submission, obtain clearance data from state and contactInfo to add default values for email and phone
                    let submissionFormData = this.props.submission
                    if (!isEmpty(submissionFormData) && isEmpty(submissionFormData.contactInfo)) {
                        submissionFormData = Object.assign(submissionFormData, {
                            contactInfo: {
                                email: this.props.user.email,
                                phone: this.props.user.phone,
                            }
                        })
                    }
                    return <WrappedComponent {...this.props} submission={submissionFormData} />
                }
            }
            return null;
        }
    }

    const mapStateToProps = state => ({
        user: state.user,
        submission: state.app.submission
      })

    return connect(mapStateToProps)(WithSubmissionComponent)
}

export default withSubmission;
